/**
 * Parses a coordinate string (e.g., "55.588, 23.765") into latitude and longitude
 * @param coordinateString - String in format "latitude, longitude"
 * @returns Object with latitude and longitude, or { latitude: 0, longitude: 0 } if invalid
 */
export const parseCoordinates = (coordinateString: string): { latitude: number; longitude: number } => {
  if (!coordinateString.trim()) {
    return { latitude: 0, longitude: 0 };
  }

  const parts = coordinateString.split(',').map(part => part.trim());
  if (parts.length === 2) {
    const lat = parseFloat(parts[0]);
    const lng = parseFloat(parts[1]);
    return {
      latitude: isNaN(lat) ? 0 : lat,
      longitude: isNaN(lng) ? 0 : lng
    };
  }

  return { latitude: 0, longitude: 0 };
};

/**
 * Formats latitude and longitude into a display string
 * @param lat - Latitude
 * @param lng - Longitude
 * @returns Formatted string "lat, lng" or empty string if invalid/undefined
 */
export const formatCoordinates = (lat: number | null | undefined, lng: number | null | undefined): string => {
  // Return empty string if either is null, undefined, or NaN
  if (lat === null || lng === null || lat === undefined || lng === undefined || isNaN(lat) || isNaN(lng)) return '';
  // Return empty string if both are 0
  if (lat === 0 && lng === 0) return '';
  return `${lat}, ${lng}`;
};
